export default function VideoPlayer() {
  const videoWrapper = document.querySelectorAll<HTMLDivElement>(".js-video-player");

  if (videoWrapper && videoWrapper.length > 0) {
    videoWrapper.forEach((item) => {
      const video: HTMLVideoElement | null = item.querySelector(".js-video");
      const videoBtn: HTMLButtonElement | null = item.querySelector(".js-video-btn");

      if (video && videoBtn) {
        videoBtn.addEventListener("click", () => {
          video.play();
          video.style.opacity = "1";
          video.style.pointerEvents = "auto";
          videoBtn.setAttribute("aria-pressed", "true");
          videoBtn.style.opacity = "0";
          videoBtn.style.pointerEvents = "none";
        });
      }
    });
  }
}
